<template>
<div class="pc-parts" :class="part.class">
  <!-- <span class="icon-mb"></span>&nbsp; -->
  <span>{{ part.name }}</span>
  <!-- <span> ${{ part.price }}</span> -->
</div>
</template>

<script>
export default {
  name: 'PcParts',
  props: ['part'],
}
</script>

<style lang="scss">
.pc-parts {
    padding: 8px 15px;
    border-radius: 9px;
    border: solid 3px #fff;
    color: #fff;
    width: 336px;
    min-height: 47px;
    margin: 2px 15px;
    box-sizing: border-box;
    -moz-user-select: none;
    user-select: none;
    transition: transform 0.3s;
    overflow: hidden;
    cursor: grab;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
        transform: scale(1.04);
    }
}

.CPU{
  background-color: #ff5527;
  order: 1;
}

.RAM{
  background-color: #319576;
  order: 2;
}

.SSD{
  background-color: #ffae00;
  order: 3;
}

.HDD{
  background-color: #898d8c;
  order: 4;
}

.GPU{
  background-color: #9b3454;
  order: 5;
}

.MB{
  background-color: #1e2a59;
  order: 6;
}

.WIFI{
  background-color: #01b3ed;
  order: 7;
}

.PSU{
  background-color: #5c2775;
  order: 8;
}

.DVD{
  background-color: #1a5359;
  order: 9;
}

.CASE{
  background-color: #000;
  order: 10;
}

.red {
    .CPU {
        background-color: #430000;
    }

    .RAM {
        background-color: #620000;
    }

    .SSD {
        background-color: #7b0000;
    }

    .HDD {
        background-color: #9b0000;
    }

    .GPU {
        background-color: #a30000;
    }

    .MB {
        background-color: #b40000;
    }

    .WIFI {
        background-color: #bb0000;
    }

    .PSU {
        background-color: #cf0000;
    }

    .DVD {
        background-color: #dc0000;
    }

    .CASE {
        background-color: #ea0000;
    }
}

.blue {
    .CPU {
        background-color: #121935;
    }

    .RAM {
        background-color: #1c2651;
    }

    .SSD {
        background-color: #213377;
    }

    .HDD {
        background-color: #2d4193;
    }

    .GPU {
        background-color: #354ca7;
    }

    .MB {
        background-color: #405dd2;
    }

    .WIFI {
        background-color: #5c7dff;
    }

    .PSU {
        background-color: #5c86ff;
    }

    .DVD {
        background-color: #5c9dff;
    }

    .CASE {
        background-color: #5ca9ff;
    }
}

.green {
    .CPU {
        background-color: #022306;
    }

    .RAM {
        background-color: #023008;
    }

    .SSD {
        background-color: #03410b;
    }

    .HDD {
        background-color: #01480a;
    }

    .GPU {
        background-color: #024d0b;
    }

    .MB {
        background-color: #00570a;
    }

    .WIFI {
        background-color: #00630b;
    }

    .PSU {
        background-color: #026f0e;
    }

    .DVD {
        background-color: #00690c;
    }

    .CASE {
        background-color: #067211;
    }
}

.purple {
    .CPU {
        background-color: #2c1235;
    }

    .RAM {
        background-color: #3e1a4a;
    }

    .SSD {
        background-color: #4e215e;
    }

    .HDD {
        background-color: #5f2973;
    }

    .GPU {
        background-color: #6f3186;
    }

    .MB {
        background-color: #823a9d;
    }

    .WIFI {
        background-color: #9442b3;
    }

    .PSU {
        background-color: #a54ac8;
    }

    .DVD {
        background-color: #b651dd;
    }

    .CASE {
        background-color: #c65af0;
    }
}

.dark {
    .CPU {
        background-color: #000;
    }

    .RAM {
        background-color: #111;
    }

    .SSD {
        background-color: #222;
    }

    .HDD {
        background-color: #343434;
    }

    .GPU {
        background-color: #434343;
    }

    .MB {
        background-color: #4a4a4a;
    }

    .WIFI {
        background-color: #5c5c5c;
    }

    .PSU {
        background-color: #626262;
    }

    .DVD {
        background-color: #6a6a6a;
    }

    .CASE {
        background-color: #777;
    }
}
</style>
